import React from 'react';
import { NavLink } from 'react-router-dom';

const filters = [
    { label: "Bedrooms", filter: ".cat-4" },
    { label: "Doors", filter: ".cat-6" },
    { label: "Media Wall", filter: ".cat-3" },
    { label: "Wardrobes", filter: ".cat-2" },
    { label: "Home Office", filter: ".cat-5" },
    { label: "Kitchen", filter: ".cat-1" },
    // { label: "Office", filter: ".cat-7" },
    // { label: "Bookshelves", filter: ".cat-8" },

];

const projects = [
    {
        image: require('./../../images/new-images/k1.jpg'),
        filter: 'cat-1'
    },
    {
        image: require('./../../images/new-images/k2.jpg'),
        filter: 'cat-1'
    },
    {
        image: require('./../../images/new-images/k3.jpg'),
        filter: 'cat-1'
    },
    {
        image: require('./../../images/new-images/k4.jpg'),
        filter: 'cat-1'
    },
    {
        image: require('./../../images/new-images/k5.jpg'),
        filter: 'cat-1'
    },
    {
        image: require('./../../images/new-images/k6.jpg'),
        filter: 'cat-1'
    },
    {
        image: require('./../../images/new-images/bw1.jpg'),
        filter: 'cat-2'
    },
    {
        image: require('./../../images/new-images/bw2.jpg'),
        filter: 'cat-2'
    },
    {
        image: require('./../../images/new-images/bw3.jpg'),
        filter: 'cat-2'
    },
    {
        image: require('./../../images/new-images/bw4.jpg'),
        filter: 'cat-2'
    },
    {
        image: require('./../../images/new-images/tu1.jpg'),
        filter: 'cat-3'
    },
    {
        image: require('./../../images/new-images/tu2.jpg'),
        filter: 'cat-3'
    },
    {
        image: require('./../../images/new-images/tu3.jpg'),
        filter: 'cat-3'
    },
    {
        image: require('./../../images/new-images/tu4.jpg'),
        filter: 'cat-3'
    },
    {
        image: require('./../../images/new-images/tu5.jpg'),
        filter: 'cat-3'
    },
    {
        image: require('./../../images/new-images/b1.jpg'),
        filter: 'cat-4'
    },
    {
        image: require('./../../images/new-images/b2.jpg'),
        filter: 'cat-4'
    },
    {
        image: require('./../../images/new-images/b3.jpg'),
        filter: 'cat-4'
    },
    {
        image: require('./../../images/new-images/b4.jpg'),
        filter: 'cat-4'
    },
    {
        image: require('./../../images/new-images/b5.jpg'),
        filter: 'cat-4'
    },
    {
        image: require('./../../images/new-images/b6.jpg'),
        filter: 'cat-4'
    },
    {
        image: require('./../../images/new-images/wd1.jpg'),
        filter: 'cat-5'
    },
    {
        image: require('./../../images/new-images/wd2.jpg'),
        filter: 'cat-5'
    },
    {
        image: require('./../../images/new-images/wd3.jpg'),
        filter: 'cat-5'
    },
    {
        image: require('./../../images/new-images/wd4.jpg'),
        filter: 'cat-5'
    },
    {
        image: require('./../../images/icon/icon9.jpg'),
        filter: 'cat-6'
    },
    {
        image: require('./../../images/icon/icon4.png'),
        filter: 'cat-6'
    },
    {
        image: require('./../../images/new-images/s3.jpg'),
        filter: 'cat-6'
    },
    {
        image: require('./../../images/new-images/s4.jpg'),
        filter: 'cat-6'
    },
    {
        image: require('./../../images/new-images/s5.jpg'),
        filter: 'cat-6'
    },
    // {
    //     image: require('./../../images/new-images/o1.jpg'),
    //     filter: 'cat-7'
    // },
    // {
    //     image: require('./../../images/new-images/o2.jpg'),
    //     filter: 'cat-7'
    // },
    // {
    //     image: require('./../../images/new-images/o3.jpg'),
    //     filter: 'cat-7'
    // },
    // {
    //     image: require('./../../images/new-images/o4.jpg'),
    //     filter: 'cat-7'
    // },
    // {
    //     image: require('./../../images/new-images/o5.jpg'),
    //     filter: 'cat-7'
    // },
    // {
    //     image: require('./../../images/new-images/o6.jpg'),
    //     filter: 'cat-7'
    // },
    // {
    //     image: require('./../../images/new-images/bs1.jpg'),
    //     filter: 'cat-8'
    // },
    // {
    //     image: require('./../../images/new-images/bs2.jpg'),
    //     filter: 'cat-8'
    // },
    // {
    //     image: require('./../../images/new-images/bs3.jpg'),
    //     filter: 'cat-8'
    // },
    // {
    //     image: require('./../../images/new-images/bs4.jpg'),
    //     filter: 'cat-8'
    // },
    // {
    //     image: require('./../../images/new-images/bs5.jpg'),
    //     filter: 'cat-8'
    // },
    // {
    //     image: require('./../../images/new-images/bs6.jpg'),
    //     filter: 'cat-8'
    // },
    
]

class OurProject4 extends React.Component {
    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/masonary.js');

    };
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-gray mobile-page-padding">
                    <div className="container">
                        {/* TITLE START */}
                        <div className="section-head">
                            <div className="mt-separator-outer separator-center">
                                <div className="mt-separator">
                                    <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Our</span> Gallery</h2>
                                </div>
                            </div>
                        </div>
                        {/* TITLE END */}
                        {/* PAGINATION START */}
                        <div className="filter-wrap p-b30 text-center">
                            <ul className="filter-navigation inline-navigation masonry-filter link-style  text-uppercase">
                                <li className="active"><NavLink to={"#"} data-filter="*" data-hover="All">All</NavLink></li>
                                {filters.map((item, index) => (
                                    <li key={index}><NavLink to={"#"} data-filter={item.filter} data-hover={item.label}>{item.label}</NavLink></li>
                                ))}
                            </ul>
                        </div>
                        {/* PAGINATION END */}
                        {/* GALLERY CONTENT START */}
                        <div className="portfolio-wrap mfp-gallery work-grid row clearfix">
                            {projects.map((item, index) => (
                                <div key={index} className={`${item.filter} masonry-item col-md-4 col-sm-6 m-b30`}>
                                    <img src={item.image} alt="" width={'100%'} height={'250px'} />
                                </div>
                            ))}
                        </div>
                        {/* GALLERY CONTENT END */}
                        {/* <div className="m-t50 text-center">
                            <NavLink to={"#"} className="site-button btn-effect">Load More</NavLink>
                        </div> */}
                    </div>
                </div>
            </>
        );
    }
};

export default OurProject4;